import React from "react";
import { useDispatch, useSelector } from "react-redux";
import withModal from "../withModal";
import MaterialModal from "../MaterialModal";
import ClientVariableMain from "./ClientVariableMain";
import { hideModal } from "../../../actions/actionCreators";
import { IAppState } from "../../../types/stores";

interface IVariableAdminModal {
    isOpen: boolean;
    modalProps: {
        scope: string;
    };
}

const VariableAdminModal: React.FC<IVariableAdminModal> = ({ modalProps, isOpen }: IVariableAdminModal) => {
    const dispatch = useDispatch();

    //Props
    const roles = useSelector((state: IAppState) => state.session.roles || []);
    const enabledFeatures = useSelector((state: IAppState) => state.session.enabledFeatures);

    //Roles
    const hasSuperAdmin = roles.includes("Super Admin");
    const hasExperianAdmin = roles.includes("Experian Admin");

    //Features
    const hasClientVariablesManagement = enabledFeatures.includes("client-variables-management");

    const hide = () => dispatch(hideModal("VARIABLE_ADMIN"));

    const getTitle = () => {
        const scope = modalProps.scope || "CampaignFlow";
        let title = "Variables Admin";
        if (scope == "OfferCode") {
            title = "Offer Codes";
        }
        return title;
    };

    return modalProps.scope != "CampaignFlow" || hasSuperAdmin || hasExperianAdmin || hasClientVariablesManagement ? (
        <MaterialModal
            id="variable-admin-modal"
            isOpen={isOpen}
            onClose={hide}
            title={getTitle()}
            onPrimaryButtonRequest={hide}
            showPrimaryButton={false}
            cancelButtonText="Close"
        >
            <ClientVariableMain scope={modalProps.scope} />
        </MaterialModal>
    ) : null;
};

export default withModal(VariableAdminModal, "VARIABLE_ADMIN");
